import React from 'react';
import styled from 'styled-components';
import { standardColours, brandColours } from '../../styles';

const StyledDate = styled.span`
  color: ${standardColours.white};
  background-color: ${brandColours.secondary};
  padding: 5px 10px;
  border-radius: 16px;
`;

export const Date = ({ humanDate, machineDate, ...props }) => (
  <StyledDate {...props}>
    <time dateTime={machineDate}> {humanDate}</time>
  </StyledDate>
);
